import React, { useContext } from 'react'
import { Menu, MenuButton, MenuList } from '@chakra-ui/react'
import { IconGeneric } from 'styled/Icons.styled'
import { HiDotsHorizontal } from 'react-icons/hi'
import { OptionsBorrador } from './OptionsPass/OptionsBorrador'
import { OptionsPresentado } from './OptionsPass/OptionsPresentado'
import { OptionsAutorizados } from './OptionsPass/OptionsAutorizados'
import { useNavigate } from 'react-router-dom'
import PassCrudContext from 'context/PassCrudContext'
import { OptionsRevisado } from './OptionsPass/OptionsRevisado'
import environment from 'constants/apiConst'
import { AuthContext } from 'context/AuthContext'
import { useSelector } from 'react-redux'
import { getValidatedQualifiedUser } from 'utils/type-check-utils'

const MenuPass = ({ data }) => {
  const { changeStatus, onOpenReturnReason, setReturnReason, setDataToShow } =
    useContext(PassCrudContext)
  const { authUser } = useContext(AuthContext)
  const dataUser = useSelector((state) => state.auth?.dataUser)
  const navigate = useNavigate()

  const handlePresent = status => {
    if (data?.status_dispatchPass) {
      const dataCahnge = {
        id: data.id,
        status_dispatchPass: status,
        is_integration_certificate_reentry: !!data.is_integration_certificate_reentry,
        integration_certificate_code: data.integration_certificate_code || ''
      }

      if (status === 'DEVUELTO') {
        setReturnReason(dataCahnge)
        onOpenReturnReason()
      } else {
        changeStatus(dataCahnge, () => {}, environment.CHANGESTATUSDISPACTH)
        if (status === 'REVISADO') {
          setDataToShow(data)
          const qualifiedParam = encodeURIComponent(
            getValidatedQualifiedUser(data.name_qualified, { authUser, dataUser })
          )
          if (!qualifiedParam) {
            console.error("Error: Usuario calificado no válido")
            return
          }
          navigate(
            `/CheckPassOutput?qualifiedUser=${qualifiedParam}&numberForm=${data.passForm_number}&id=${data.id}&status=${data.status_dispatchPass}&typeO=Dispatch`
          )
        }
      }
    }

    if (data?.status_entryPass) {
      const dataCahnge = {
        id: data.id,
        status_entryPass: status
      }
      if (status === 'DEVUELTO') {
        onOpenReturnReason()
        setReturnReason(dataCahnge)
      } else {
        changeStatus(dataCahnge, () => {}, environment.CHANGESTATUSPASS)
        if (status === 'REVISADO') {
          setDataToShow(data)
          const qualifiedParam = encodeURIComponent(
            getValidatedQualifiedUser(data.name_qualified, { authUser, dataUser })
          )
          if (!qualifiedParam) {
            console.error("Error: Usuario calificado no válido")
            return
          }
          navigate(
            `/CheckPassEntry?qualifiedUser=${qualifiedParam}&numberForm=${data.passForm_number}&id=${data.id}&status=${data.status_entryPass}&typeO=`
          )
        }
      }
    }
  }

  /*  if (data.status_entryPass === "AUTORIZADO") return "";
   */
  return (
    <Menu>
      <>
        <MenuButton>
          <IconGeneric as={HiDotsHorizontal} color='#00000085' />
        </MenuButton>
        {data.status_entryPass ? (
          <MenuList
            borderRadius='none'
            py={0}
            style={{ boxSizing: 'border-box' }}
          >
            {data.status_entryPass === 'BORRADOR' ||
              data.status_entryPass === 'DEVUELTO' ? (
              <OptionsBorrador data={data} handlePresent={handlePresent} />
            ) : data.status_entryPass === 'PRESENTADO'? (
              <OptionsPresentado data={data} handlePresent={handlePresent} />
            ) : data.status_entryPass === 'AUTORIZADO' ? (
              <OptionsAutorizados data={data} handlePresent={handlePresent} />
            ) : data.status_entryPass === 'REVISADO' ? (
              <OptionsRevisado data={data} handlePresent={handlePresent} />
            ) : ''
            }
          </MenuList>
        ) : (
          <MenuList
            borderRadius='none'
            py={0}
            style={{ boxSizing: 'border-box' }}
          >
            {data.status_dispatchPass === 'BORRADOR' ||
              data.status_dispatchPass === 'DEVUELTO' ? (
              <OptionsBorrador data={data} handlePresent={handlePresent} />
            ) : data.status_dispatchPass === 'PRESENTADO' ? (
              <OptionsPresentado data={data} handlePresent={handlePresent} />
            ) : data.status_dispatchPass === 'AUTORIZADO' ? (
              <OptionsAutorizados data={data} handlePresent={handlePresent} />
            ) : data.status_dispatchPass === 'REVISADO' ? (
              <OptionsRevisado data={data} handlePresent={handlePresent} />
            ) : ''}
          </MenuList>
        )}
      </>
    </Menu>
  )
}

export default MenuPass
